import { useEffect } from 'react'
import { useGetQuery } from '../useGetQuery'

export const useNearbyDungeons = ({ lat, lng } = {}) => {
  const { data, isFetching, setPath, setEnabled } = useGetQuery({ enabled: false, url: '' })

  useEffect(() => {
    if (!lat || !lng) return
    setEnabled(true)
    setPath(`/dungeons/nearby?lat=${lat}&lng=${lng}`)
  }, [lat, lng])

  return { dungeons: data?.dungeons || [], globalDungeon: data?.global || null, isFetching }
}

export const useNearbyPlaces = ({ lat, lng, limit = 50 } = {}) => {
  const { data, isFetching, setPath, setEnabled } = useGetQuery({ enabled: false, url: '' })

  useEffect(() => {
    if (!lat || !lng) return
    setEnabled(true)
    setPath(`/places?lat=${lat}&lng=${lng}&limit=${limit}`)
  }, [lat, lng, limit])

  return { addresses: data?.addresses?.rows || [], isFetching }
}
